<template>
  <div class="wg-col wg-xs-12" style="padding: 2%">
    <div style="font-size: 24px" class="com-anm22-app-text-m">
      {{ cardType.name }}
    </div>
    <div class="vertical-height-div" style="height: 20px"></div>

    <span>{{ $anm22.strLang(lang, "Name", "Nome") }}</span>
    <div class="wg-col">
      <input
        class="input-elem print-elem com-anm22-app-input-text"
        type="text"
        v-model="cardType.name"
      />
      <div class="vertical-height-div" style="height: 12px"></div>
    </div>
    
    <div class="vertical-height-div" style="height: 12px"></div>
    <span style="font-weight: bold;">Design</span>
    <div class="vertical-height-div" style="height: 12px"></div>

    <span>{{ $anm22.strLang(lang, "Background color", "Colore sfondo") }}</span>
    <div class="wg-col">
      <input
        class="input-elem print-elem com-anm22-app-input-text"
        type="text"
        v-model="cardType.bgColor"
      />
      <div class="vertical-height-div" style="height: 12px"></div>
    </div>

    <span>{{ $anm22.strLang(lang, "Text color", "Colore testo") }}</span>
    <div class="wg-col">
      <input
        class="input-elem print-elem com-anm22-app-input-text"
        type="text"
        v-model="cardType.textColor"
      />
      <div class="vertical-height-div" style="height: 12px"></div>
    </div>

    <span>{{ $anm22.strLang(lang, "Image URL", "URL immagine") }}</span>
    <div class="wg-col">
      <input
        class="input-elem print-elem com-anm22-app-input-text"
        type="text"
        v-model="cardType.cardImage"
      />
      <div class="vertical-height-div" style="height: 12px"></div>
      <div
        id="pass-image"
        class="pass-image"
        :style="{ backgroundImage: 'url(\'' + cardType.cardImage + '\')', backgroundColor: cardType.bgColor ? cardType.bgColor : '#777777' }"
      >
        <div id="qrcode"></div>
      </div><div
        id="pass-image"
        class="pass-image"
        :style="{ backgroundColor: cardType.bgColor ? cardType.bgColor : '#777777' }"
      >
        <div class="pass-image-wallet-title" :style="{ color: cardType.textColor ? cardType.textColor : '#000000' }">Apple/Google Wallet</div>
        <div class="pass-image-type" :style="{ color: cardType.textColor ? cardType.textColor : '#000000' }">{{ cardType.name }}</div>
        <div id="qrcode"></div>
      </div>
      <div class="vertical-height-div" style="height: 12px"></div>
    </div>

    <div class="vertical-height-div" style="height: 12px"></div>
    <span style="font-weight: bold;">{{ $anm22.strLang(lang, "Type", "Tipologia") }}</span>
    <div class="vertical-height-div" style="height: 12px"></div>

    <span>{{ $anm22.strLang(lang, "Permanent pass", "Pass permanent") }}</span>
    <div class="wg-col">
      <select
        class="input-elem print-elem com-anm22-app-select"
        v-model="cardType.isPermanent"
      >
        <option :value="false">
          {{ $anm22.strLang(lang, "No", "No") }}
        </option>
        <option :value="true">
          {{ $anm22.strLang(lang, "Yes", "Si") }}
        </option>
      </select>
      <div class="vertical-height-div" style="height: 12px"></div>
    </div>

    <span>{{ $anm22.strLang(lang, "Pass entity", "Entità pass") }}</span>
    <div class="wg-col">
      <select
        class="input-elem print-elem com-anm22-app-select"
        v-model="cardCategory"
      >
        <option value="person">
          {{ $anm22.strLang(lang, "Person", "Persona") }}
        </option>
        <option value="vehicle">
          {{ $anm22.strLang(lang, "Vehicle", "Veicolo") }}
        </option>
        <option value="hospitality">
          {{ $anm22.strLang(lang, "Hospitality", "Hospitality") }}
        </option>
      </select>
      <div class="vertical-height-div" style="height: 12px"></div>
    </div>  

    <div class="vertical-height-div" style="height: 12px"></div>
    <span style="font-weight: bold;">{{ $anm22.strLang(lang, "Rules", "Regole") }}</span>
    <div class="vertical-height-div" style="height: 12px"></div>

    <span v-if="cardCategory === 'person'">{{
      $anm22.strLang(lang, "FMI Member required", "Tessera FMI richiesta")
    }}</span>
    <div v-if="cardCategory === 'person'" class="wg-col">
      <select
        class="input-elem print-elem com-anm22-app-select"
        v-model="cardType.requiredFmiMember"
      >
        <option :value="false">
          {{ $anm22.strLang(lang, "No", "No") }}
        </option>
        <option :value="true">
          {{ $anm22.strLang(lang, "Yes", "Si") }}
        </option>
      </select>
      <div class="vertical-height-div" style="height: 12px"></div>
    </div>

    <span v-if="cardType.isPermanent">{{
      $anm22.strLang(
        lang,
        "Permanent explode enabled",
        "Abilita divisione pass permanent"
      )
    }}</span>
    <div v-if="cardType.isPermanent" class="wg-col">
      <select
        class="input-elem print-elem com-anm22-app-select"
        v-model="cardType.permanentExplode"
      >
        <option :value="false">
          {{ $anm22.strLang(lang, "No", "No") }}
        </option>
        <option :value="true">
          {{ $anm22.strLang(lang, "Yes", "Si") }}
        </option>
      </select>
      <div class="vertical-height-div" style="height: 12px"></div>
    </div>

    <span v-if="!cardType.requiredFmiMember">{{
      $anm22.strLang(lang, "Short data form", "Form dati compatto")
    }}</span>
    <div v-if="!cardType.requiredFmiMember" class="wg-col">
      <select
        class="input-elem print-elem com-anm22-app-select"
        v-model="cardType.shortForm"
      >
        <option :value="false">
          {{ $anm22.strLang(lang, "No", "No") }}
        </option>
        <option :value="true">
          {{ $anm22.strLang(lang, "Yes", "Si") }}
        </option>
      </select>
      <div class="vertical-height-div" style="height: 12px"></div>
    </div>

    <span>{{
      $anm22.strLang(
        lang,
        "Editable when enabled",
        "Modificabile una volta compilato"
      )
    }}</span>
    <div class="wg-col">
      <select
        class="input-elem print-elem com-anm22-app-select"
        v-model="cardType.editRule"
      >
        <option :value="0">
          {{ $anm22.strLang(lang, "No", "No") }}
        </option>
        <option :value="1">
          {{ $anm22.strLang(lang, "Yes", "Si") }}
        </option>
      </select>
      <div class="vertical-height-div" style="height: 12px"></div>
    </div>

    <span>{{ $anm22.strLang(lang, "Default role", "Ruolo predefinito") }}</span>
    <div class="wg-col">
      <select
        class="input-elem print-elem com-anm22-app-select"
        v-model="cardType.defaultRole"
      >
        <option :value="0">
          {{ $anm22.strLang(lang, "Default role", "Nessun ruolo predefinito") }}
        </option>
        <option
          v-for="(role, index) in ticketRoles"
          :key="index"
          :value="role.id"
        >
          {{ role.name }}
        </option>
      </select>
      <div class="vertical-height-div" style="height: 12px"></div>
    </div>

    <div
      >{{
        $anm22.strLang(lang, "Send copy via e-mail", "Invia copia via e-mail")
      }}<br /><span class="form-note">⚠️ {{
        $anm22.strLang(
          lang,
          "This feature is not compatible with some type of SIAE tickets.",
          "Questa funzionalità non è compatibile con alcuni biglietti SIAE."
        )
      }}</span>
    </div>
    <div class="wg-col">
      <select
        class="input-elem print-elem com-anm22-app-select"
        v-model="cardType.emailVersion"
      >
        <option :value="false">
          {{ $anm22.strLang(lang, "No", "No") }}
        </option>
        <option :value="true">
          {{ $anm22.strLang(lang, "Yes", "Si") }}
        </option>
      </select>
      <div class="vertical-height-div" style="height: 12px"></div>
    </div>

    <span>{{
      $anm22.strLang(
        lang,
        "Show note about required bracelet for track entry",
        "Mostrare nota di bracciale necessario per accesso in pista"
      )
    }}</span>
    <div class="wg-col">
      <select
        class="input-elem print-elem com-anm22-app-select"
        v-model="cardType.requiredBracelet"
      >
        <option :value="false">
          {{ $anm22.strLang(lang, "No", "No") }}
        </option>
        <option :value="true">
          {{ $anm22.strLang(lang, "Yes", "Si") }}
        </option>
      </select>
      <div class="vertical-height-div" style="height: 12px"></div>
    </div>

    <div class="vertical-height-div" style="height: 20px"></div>

    <div class="wg-row">
      <input
        type="button"
        :value="$anm22.strLang(lang, 'Save', 'Salva')"
        @click="saveTicketType"
      />
      <input
        type="button"
        :value="$anm22.strLang(lang, 'Delete', 'Elimina')"
        class="red"
        style="margin-left: 10px"
        @click="removeCardType()"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import WGPageControls from "../../../../world/spa/components/WGPageControls.vue";
import motorsport from "../../libs/motorsport";

export default {
  components: {
    WGPageControls,
  },
  data() {
    return {
      cardType: null,
      mode: "edit",
      openModal: false,
      currentTicket: {},
      pageResultsNum: 50,
      pageOffset: 0,
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      windowWidth: (state) => state.windowWidth,
    }),
    ticketTypeId() {
      return this.$route.params.id;
    },
    cardCategory: {
      get() {
        if (this.cardType && this.cardType.isFood) return "hospitality";
        if (this.cardType && this.cardType.isVehicle) return "vehicle";
        return "person";
      },
      set(value) {
        if (value === "hospitality") {
          this.cardType.isVehicle = 0;
          this.cardType.isFood = 1;
        } else if (value === "vehicle") {
          this.cardType.isVehicle = 1;
          this.cardType.isFood = 0;
        } else {
          this.cardType.isVehicle = 0;
          this.cardType.isFood = 0;
        }
      },
    },
    ticketTypesList() {
      return this.ticketTypes;
    },
    ticketRoles() {
      return motorsport.getRoles();
    },
  },
  methods: {
    loadData() {
      this.$http
        .get("tickets/types/" + this.$route.params.id)
        .then((response) => {
          this.cardType = response.data.cardType;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveTicketType() {
      this.$http
        .post(
          "tickets/types/" + this.$route.params.id,
          {
            cardType: this.cardType,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$anm22.eventBus.$emit("world-headbar-show-message", {
            text: this.$anm22.strLang(
              this.lang,
              "Ticket type successfully saved",
              "Tipologia biglietto aggiornata"
            ),
            type: "confirm",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    removeCardType() {
      this.cardType.deleted = true;
      this.$http
        .post(
          "tickets/types/" + this.$route.params.id,
          {
            cardType: this.cardType,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.loadData();
        })
        .catch((error) => {
          console.log(error);
        });
      this.$router.push("/tickets/types");
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
.tickets-list {
  overflow-x: auto;

  .ticket-row {
    border-radius: 8px;
    min-height: 49px;
    padding: 5px;
    flex-wrap: nowrap;
    cursor: pointer;
    max-width: 1700px;

    &:hover {
      background-color: #f9f9f9;
    }
    div {
      display: inline-block;
      vertical-align: top;
      white-space: normal;
      padding: 11px;

      &.code {
        flex: 1;
        width: 10%;
        min-width: 60px;
        word-wrap: break-word;
      }
      &.name {
        flex: 3;
        width: 15%;
        min-width: 120px;
      }
      &.category {
        flex: 1;
        width: 15%;
        min-width: 120px;
      }
      &.quantity {
        width: 10%;
        min-width: 60px;
      }
      &.color {
        width: 42px;

        .color-preview {
          border: 1px solid #ddd;
          border-radius: 10px;
          box-sizing: border-box;
          width: 16px;
          height: 16px;
          padding: 0;
        }
      }
      &.edit,
      &.delete {
        padding: 8px;
        width: 36px;

        .edit-btn,
        .delete-btn {
          width: 20px;
          height: 20px;
          cursor: pointer;
        }
      }
    }

    &.header {
      div {
        font-weight: 600;
      }

      &:hover {
        background: none !important;
      }
    }
  }

  .empty-list-msg {
    padding: 16px;
  }
}

.tickets-list-menu {
  align-items: center;
  max-width: 1700px;
}

.form-note {
  color: #666;
  font-size: 12px;
}

.pass-image {
  background-color: #ccc;
  background-repeat: no-repeat;
  background-size: 100% auto;
  margin: 0 5px;
  width: 90%;
  max-width: 150px;
  height: 200px;
  position: relative;
  border-radius: 3px;
  overflow: hidden;
  box-sizing: border-box;
  display: inline-block;
  user-select: none;

  &.disabled {
    border-radius: 6px 6px 0 0;
    height: 75px;
    mask-image: linear-gradient(#000000ff, transparent);
    -webkit-mask-image: -webkit-gradient(
      linear,
      left top,
      s left bottom,
      from(#000000ff),
      to(#00000000)
    );
  }

  .pass-image-wallet-title {
    font-size: 10px;
    padding: 8px 16px;
    color: #000000;
    width: 100%;
    border-bottom: 1px solid #666;
  }
  
  .pass-image-type {
    font-size: 16px;
    padding: 8px 16px;
    color: #000000;
  }

  #qrcode {
    box-sizing: border-box;
    padding: 5px;
    background-color: #fff;
    width: 85px;
    height: 85px;
    position: absolute;
    left: calc(50% - 42px);
    top: 95px;
    border-radius: 2px;
  }
}
</style>
